"use client";

import React from "react";
import "../animations/animate.css";
import AnimatedBody from "../animations/AnimatedBody.tsx";
import AnimatedTitle from "../animations/AnimatedTitle.tsx";
import Link from "next/link";
import { formations, Formation } from "./formationsData.ts";

interface FormationsProps {
  showAll?: boolean;
}

const Formations = ({ showAll = false }: FormationsProps) => {
  const displayedFormations = showAll ? formations : formations.slice(0, 2);
  return (
    <section
      className="relative z-10 w-full items-center justify-center overflow-hidden bg-[#0E1016] bg-cover bg-center pt-16 pb-36 md:pt-20 md:pb-44 lg:pt-20 lg:pb-56"
      id="formations"
    >
      <div className="mx-auto flex w-[90%] flex-col items-center justify-center lg:max-w-[1212.8px]">
        <AnimatedTitle
          text={"Formations"}
          className={
            "mb-10 self-start text-left text-[40px] font-bold leading-[0.9em] tracking-tighter text-[#e4ded7] sm:text-[45px] md:mb-16 md:text-[60px] lg:text-[80px]"
          }
          wordSpace={"mr-[14px]"}
          charSpace={"mr-[0.001em]"}
        />

        <div className="flex w-full flex-col gap-12 pr-[20em] text-[#e4ded7]">
          {displayedFormations.map((formation: Formation, index: number) => (
            <div
              key={index}
              className="flex flex-col border-b border-b-gray-800 pb-8"
            >
              <div className="flex items-center justify-between">
                <AnimatedBody
                  delay={index * 0.2}
                  text={`${formation.diploma}`}
                  className="text-2xl font-bold text-white"
                />
                <AnimatedBody
                  delay={index * 0.2 + 0.05}
                  text={`${formation.year}`}
                  className="text-sm"
                />
              </div>
              <AnimatedBody
                delay={index * 0.2 + 0.1}
                text={`${formation.field}`}
                className="mb-2 text-lg text-indigo-400"
              />
              <AnimatedBody
                delay={index * 0.2 + 0.15}
                text={`${formation.institution} - ${formation.location}`}
                className="mb-1 text-base"
              />
              {formation.status === "en cours" && (
                <AnimatedBody
                  delay={index * 0.2 + 0.2}
                  text="En cours"
                  className="text-sm italic text-yellow-400"
                />
              )}
              {showAll &&
                formation.highlights &&
                formation.highlights.length > 0 && (
                  <div className="mt-4">
                    {formation.highlights.map(
                      (highlight: string, i: number) => (
                        <AnimatedBody
                          key={i}
                          delay={index * 0.2 + 0.25 + i * 0.05}
                          text={`• ${highlight}`}
                          className="text-base"
                        />
                      )
                    )}
                  </div>
                )}
            </div>
          ))}
        </div>

        {!showAll && (
          <div className="mt-8 self-start">
            <Link
              href="/formations"
              className="text-2xl font-bold text-indigo-400 transition-colors hover:text-indigo-300"
            >
              <AnimatedBody text="Voir toutes mes formations" />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default Formations;
